<div class="outer">
    <div class="container done-notice">
        <span [innerHTML]="message"></span>
    </div>
</div>